<template lang="pug">
v-container
    v-layout(row wrap)
        v-flex(xs12)
            v-card.transparent(dark flat)
                v-card-text.text-center
                    h2.pt-10.display-2.white--text SUPLENCIAS
                    h3.font-weight-regular Incapacidad Temporal (Enfermedad, Riesgo Profesional y Maternidad)
                v-card-text.no-padding.mt-5
                    v-layout(row wrap)
                        v-flex(xs12 md6)
                            h3.display-1.font-weight-light.white--text.pb-1 Información:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding
                                p.subtitle-1(style="line-height:22px;text-align:justify;").no-margin.pt-2 La contratación de personal docene o administrativo, permite sustituir de manera temporal al personal titular del SEP, por causales de Incapacidad Temporal(enfermedad, riesgo profesional, maternidad), ejercicio sindical y beca de estudio.<br>
                                p.subtitle-1(style="line-height:22px;text-align:justify;").mt-2
                                    | <strong>Incapacidad Temporal (Enfermedad, Riesgo Profesional y Maternidad)</strong><br>
                                    | <i>El ámbito de aplicación de las suplencias por incapacidad temporal se aplica al personal docente de las Instituciones Educativas fiscales y de convenio de los Subsistemas de Educación Regular, Educación Alternativa y Especial y Educación Superior de Formación Profesional, y al personal administrativo (Secretaria/o, asistente administrativo, asistente de aula y portera/o). La contratación del personal suplente y el pago correspondiente, se efectuará en el marco de los procedimientos establecidos en el Reglamento Específico para el Procedimiento de Contratación y Pago de Suplencias por incapacidad Temporal del Magisterio Fiscal, aprobado con Resolución Ministerial No. 146/2017 de 23 de marzo de 2017. La Dirección Departamental de Educación, Subdirección de Educación correspondiente y Dirección Distrital de Educación, son los responsables de seleccionar, designar al personal suplente y suscribir el contrato de suplencias por incapacidad temporal, para las instituciones educativas correspondientes.</i>
                                p.subtitle-1(style="line-height:22px;text-align:justify;").mt-2
                                    | <strong>Por Comisión Sindical o beca de Estudio</strong><br>
                                    | <i>La suplencia por comisión sindical o beca de estudio, deben ser aprobadas por Resolución Ministerial emitida por el Ministerio de Educación, y la designación de la suplencia de cargo docente o administrativo del SEP se la procesara en planilla de haberes de acuerdo al procedimiento establecido en el presente reglamento.</i>
                                p.subtitle-1(style="line-height:22px;text-align:justify;").mt-2
                                    | <strong>Boletas de pago</strong><br>
                                    | <i>Las boletas de pago para el personal docente y administrativo del SEP, permiten validar información del pago de haberes, a objeto de brindar información al interesado.</i>
                            h3.display-1.font-weight-light.white--text.pb-1 Requisitos:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding.mt-4
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 1er. Juego Ministerio de eduación
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Solicitud de baja temporal (Formulario web encontrado en la actual página)<br>
                                    | - C.I. del asegurado(a) y del/de la beneficiario(a) (fotocopias).<br>
                                    | - Certificado de incapacidad temporal otorgado por la CNS
                                    | - Boleta de pago del último mes (fotocopia).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 2do. Juego Dirección departamental
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario 110, del Servicio (Fotocopia)<br>
                                    | - C.I. del asegurado(a) y del/de la beneficiario(a) (fotocopias).<br>
                                    | - Boleta de pago del último mes (fotocopia).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 3er. Juego Dirección distrital
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario 110, del Servicio (Fotocopia)<br>
                                    | - C.I. del asegurado(a) y del/de la beneficiario(a) (fotocopias).<br>
                                    | - Boleta de pago del último mes (fotocopia).
                            h3.display-1.font-weight-light.white--text.pb-1 Notas:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding.mt-4
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - La documentación requerida debe ser presentada en el distrito al cual el docente pertenece ya que el técnico validará esta información antes de recepcionar sus documentos.<br>
                                    | - La presentación de descargos con formularios 110 se debe realizar un mes antes del periodo (mes) al que pertenece el formulario. osease que si el formulario 110 pertenece al periodo mes de junio, se debe presentar hasta el 22 de junio en dirección distrital al que pertenece el docente.
                        v-flex(xs12 md5 offset-md-1)
                            h3.display-1.font-weight-light.white--text.text-center Solicitud de baja temporal:
                            c-form-solicitud-suplencias
            v-dialog(v-model="dialogConfirm" width=400)
                v-card
                    v-toolbar(dark color="success" dense).no-padding.no-margin
                        v-toolbar-title Archivo subido.
                        v-spacer
                        v-btn(icon dark @click="dialogConfirm = false")
                            v-icon fas fa-times
                    v-card-text.text-center.pb-5
                        h3.pt-3 Su archivo fué subido correctamente al servidor, puede verificarlo mas adelante con su ci:
                        h3.pt-2 4687156
                        v-btn(color="success" @click="dialogConfirm = false").mt-2 Aceptar
            v-dialog(v-model="dialogUltimosDec" width=600 scrollable)
                v-card
                    v-toolbar(dar color="success" dense dark).no-padding.no-margin
                        v-toolbar-title Últimos archivos (.dec) subidos por: 4434655
                        v-spacer
                        v-btn(icon dark @click="dialogUltimosDec = false")
                            v-icon fas fa-times
                    v-card-text.no-padding(style="height:305px")
                        v-data-table(:headers="headers" :items="desserts" disable-pagination hide-default-footer)
                            template(v-slot:item.estado="{ item }")
                                v-chip(color="green" dark) {{ item.estado }}
                                    v-icon(right small) fas fa-check
</template>
<script>
export default {
    data() {
        return {
            dialogConfirm: false,
            dialogUltimosDec: false,
            isLoading: false,
            headers: [
                { text: 'CI:', align: 'center', value: 'ci' },
                { text: 'Periodo (MES):', align: 'center',value: 'mes' },
                { text: 'Periodo (AÑO)', align: 'center',value: 'gestion' },
                { text: 'Fecha de presentación', align: 'center',value: 'fechaPresentacion' },
                { text: 'Estado', align: 'center',value: 'estado' }
            ],
            desserts: [
                {
                    ci: '4434655',
                    fechaPresentacion: '22/01/2019',
                    mes: 'enero',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '20/02/2019',
                    mes: 'febrero',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '19/03/2019',
                    mes: 'marzo',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '22/04/2019',
                    mes: 'abril',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '19/05/2019',
                    mes: 'mayo',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '02/06/2019',
                    mes: 'enero',
                    gestion: 2019,
                    estado: 'Presentado'
                }
            ]
        }
    },
    methods: {
        subirArchivoDec(){
            //this.isLoading = true
            this.dialogConfirm = true
            this.$snotify.success('Archivo subido correctamente.',{timeout:15000})
        }
    }
}
</script>